import { deepClone } from "./patchUtils";

export function hydrateManagerState(found, sectionTemplates) {
  // NAV default
  const navTpl = sectionTemplates?.navsection?.template1;
  const nav =
    found?.nav || {
      enabled: true,
      template: "template1",
      config: deepClone(navTpl?.config || {}),
      style: { ...(deepClone(navTpl?.style || {})), bgColor: navTpl?.style?.bgColor ?? "" },
    };

  // Sections (manager can edit values + reorder)
  const sections = (found?.sections || []).map((s) => ({
    ...s,
    style: { ...(s.style || {}), bgColor: s?.style?.bgColor ?? "" },
  }));

  // Footer default
  const footerTpl = sectionTemplates?.footersection?.template1;
  const footer =
    found?.footer || {
      enabled: true,
      template: "template1",
      config: deepClone(footerTpl?.config || {}),
      style: { ...(deepClone(footerTpl?.style || {})), bgColor: footerTpl?.style?.bgColor ?? "" },
    };

  // WhatsApp (preview only)
  const whatsapp = found?.whatsapp || null;

  const savedLang = found?.general?.language || null;

  return { nav, footer, sections, whatsapp, savedLang };
}